// component
import { ChangeEvent, useRef, useState } from 'react';

import { ISearchDB } from 'type/db';

import MemoCell from 'components/common/MemoCell';
import TableCell from 'components/common/table/cell/TableCell';
import CorePictureAvatar from 'shared/avatar/CorePictureAvatar';
import CoreSvg from 'shared/CoreSvg';
import Icon from 'shared/icons';
import CoreInput from 'shared/input/CoreInput';
import CoreTag from 'shared/tag/CoreTag';
import { EllipsisText } from 'styles/styled-components/report';
import style from 'styles/styled-components/style';
// utils
import { setCategoryColor } from 'utils/colorType';
import round, { floatFixed, roundFloat } from 'utils/round';
// type
import { search_header_arr } from 'utils/table';

const useSearchTable = () => {
	/** cell_type이 number인 cell */
	const numberCell = (value: number | null, unit: string, idx: number) => {
		const result = value === null ? '-' : `${round(value, 'round')} ${unit}`;
		return (
			<TableCell _width={search_header_arr[idx].width} cell_type="number">
				{result}
			</TableCell>
		);
	};
	/** cell_type이 percent인 cell */
	const percentCell = (value: number | null, idx: number) => {
		const result =
			value === null ? '-' : floatFixed(roundFloat(value, 'round', 2), 2) + '%';
		return (
			<TableCell _width={search_header_arr[idx].width} cell_type="number">
				{result}
			</TableCell>
		);
	};
	// 리턴할 객체
	const match_cell_mapper: Record<
		keyof ISearchDB | string,
		(data: ISearchDB, idx: number, row_idx: number) => JSX.Element
	> = {
		category: (data, idx) => {
			return (
				<TableCell _width={search_header_arr[idx].width}>
					<Grid flex="start" _padding="0 0 0 16px">
						<CoreTag
							tag_type="text"
							color_type={setCategoryColor(data?.category1)}
							value={data?.category1}
						/>
						<CoreTag
							tag_type="text"
							color_type={setCategoryColor(data?.category2)}
							value={data?.category2}
						/>
					</Grid>
				</TableCell>
			);
		},

		link: (data, idx) => (
			<TableCell _width={search_header_arr[idx].width} cell_type="center">
				<a
					href={data.link}
					target="_blank"
					onClick={(e) => {
						e.stopPropagation();
					}}
					rel="noreferrer"
				>
					<CoreSvg>
						<Icon.OutLink />
					</CoreSvg>
				</a>
			</TableCell>
		),
		profile: (data, idx) => (
			<TableCell _width={search_header_arr[idx].width}>
				<Grid flex="start" _gap="16px" _padding="0 0 0 16px">
					<CoreSvg>
						<Icon.Insta />
					</CoreSvg>
					<CorePictureAvatar
						size={'default'}
						color_type={'blue'}
						text={data?.username}
						picture={data?.profileImage}
					/>
					<Grid flex="start" direction="column" align_items="start">
						<Grid _width="160px" flex="start" _gap="8px">
							<EllipsisText typo="p_bold">{data?.username}</EllipsisText>
						</Grid>
						<EllipsisText _width="160px" typo="span">
							{data?.biography}
						</EllipsisText>
					</Grid>
				</Grid>
			</TableCell>
		),
		followers: (data, idx) => numberCell(data?.followers, '명', idx),
		memo: (data, idx) => {
			return (
				<TableCell _width={search_header_arr[idx].width}>
					<Grid flex="center" _width="100%" _height="100%">
						{/* <MemoCell initialMemo={data?.memo} /> */}
						<EllipsisText typo="p_bold">{data?.memo}</EllipsisText>
					</Grid>
				</TableCell>
			);
		},

		contents: (data, idx) => <></>, // State를 보고 있어야함으로 SearchResult에서 처리
	};

	return match_cell_mapper;
};

const { Grid, Text } = style;

export default useSearchTable;
